/**
 * Языки интерфейса админки (ТЗ ARCH-15, A-market-config `locale.languages`):
 * RU — только ru; World — en (по умолчанию) и es.
 */
export const UI_LANGUAGES = ['ru', 'en', 'es'] as const;
export type UiLanguage = (typeof UI_LANGUAGES)[number];

export function isUiLanguage(value: unknown): value is UiLanguage {
  return typeof value === 'string' && UI_LANGUAGES.some((language) => language === value);
}

/**
 * Локаль Intl для языка интерфейса. en — британский вариант (европейский рынок LENwine:
 * даты день/месяц/год), es — Испания, ru — Россия.
 */
const INTL_LOCALES: Readonly<Record<UiLanguage, string>> = {
  ru: 'ru-RU',
  en: 'en-GB',
  es: 'es-ES',
};

export function toIntlLocale(language: string): string {
  return isUiLanguage(language) ? INTL_LOCALES[language] : language;
}
